import{useFrame}from'@react-three/fiber'
import*as THREE from'three'
import type{FighterDef}from'./content'
import type{AnimationMotionContext}from'./animationVariation'
import{heroMotionFrame,type HeroOutcome}from'./heroMotion'
import type{Combatant}from'./simulation'
import{stabilizeHeroMotionFrame}from'./SupremeGameEngines'

export function useHeroChoreography(root:THREE.Group,def:FighterDef,state:Combatant,side:'left'|'right',outcome:HeroOutcome='neutral',motion?:AnimationMotionContext,presentation:'combat'|'selection'='combat',enabled=true){
 useFrame(({clock},dt)=>{
  const kinematics=motion?{vx:motion.vx,vz:motion.vz,planarSpeed:motion.planarSpeed,speedRatio:motion.speedRatio}:undefined
  const frame=stabilizeHeroMotionFrame(heroMotionFrame(def,state,side,clock.elapsedTime,outcome,kinematics))
  const facing=side==='left'?Math.PI/2:-Math.PI/2
  if(presentation==='selection'){
   root.position.x=THREE.MathUtils.damp(root.position.x,state.x,18,dt)
   root.position.y=THREE.MathUtils.damp(root.position.y,0,18,dt)
   root.position.z=THREE.MathUtils.damp(root.position.z,state.z,18,dt)
   root.rotation.x=THREE.MathUtils.damp(root.rotation.x,0,18,dt)
   root.rotation.y=THREE.MathUtils.damp(root.rotation.y,facing,14,dt)
   root.rotation.z=THREE.MathUtils.damp(root.rotation.z,0,18,dt)
   const selectionScale=THREE.MathUtils.damp(root.scale.x,1,15,dt)
   root.scale.setScalar(selectionScale)
   return
  }
  const grounded=state.aerialMode==='ground',moving=Boolean(motion&&motion.planarSpeed>.08)
  const committed=Boolean(state.attackPhase)||state.hitstun>0||state.downed
  const planarResponse=grounded?(committed?23:moving?18:14):12
  const verticalResponse=grounded?(committed?24:20):14
  root.position.x=THREE.MathUtils.damp(root.position.x,state.x+frame.x,planarResponse,dt)
  root.position.y=THREE.MathUtils.damp(root.position.y,state.y+frame.y,verticalResponse,dt)
  root.position.z=THREE.MathUtils.damp(root.position.z,state.z+frame.z,grounded?(committed?22:moving?17:13):12,dt)
  root.rotation.x=THREE.MathUtils.damp(root.rotation.x,frame.pitch,grounded?17:13,dt)
  root.rotation.y=THREE.MathUtils.damp(root.rotation.y,facing+frame.yaw,grounded?15:11,dt)
  root.rotation.z=THREE.MathUtils.damp(root.rotation.z,frame.roll,grounded?18:13,dt)
  const scale=THREE.MathUtils.damp(root.scale.x,frame.scale,15,dt)
  root.scale.setScalar(scale)
  root.userData.heroMotionFrame=frame
  if(motion)root.userData.heroMotionKinematics=motion
 })
}

